<template>
    <v-list-item>
        <v-list-item-content>
            <v-list-item-title>{{ gameClass.name }}</v-list-item-title>
            <v-list-item-subtitle class="wrap-text">
                {{ subtitle }}
            </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
            <v-btn v-if="!registrationClosed" class="mb-2" small outlined :disabled="buttonDisabled"
                :color="buttonColor" @click="() => { $emit('buttonClick', gameClass) }">
                {{ buttonText }}
            </v-btn>
            <v-btn v-if="showResultButton" small outlined color="primary"
                @click="() => goToGameclassOverview(gameClass)">
                {{ $translate('Results & Schedule') }}
            </v-btn>
        </v-list-item-action>
    </v-list-item>
</template>

<script>
export default {
    name: 'zoezi-teamsport-game-class-register-row',
    props: {
        gameClass: {
            type: Object,
            required: true
        }
    },
    computed: {
        buttonState() {
            if (this.gameClass.individual && this.gameClass.teams?.find(t => t.user_id == this.$store.state.user?.id) && this.gameClass.canBookFor == 'self') {
                return 'already-registered';
            }

            if ((!this.gameClass.max_number_of_teams || this.gameClass.spaceLeft) && this.registrationOpen) {
                return 'register';
            }

            if (this.isWatching) {
                return 'change-watching';
            } else if (!this.isLoggedIn) {
                return 'log-in-to-watch';
            } else {
                return 'watch';
            }
        },
        buttonText() {
            switch(this.buttonState) {
                case 'already-registered':
                    return this.$translate('Already registered');
                case 'register':
                    return this.$translate('Register');
                case 'change-watching':
                    return this.$translate('Change watching');
                case 'log-in-to-watch':
                    return this.$translate('Log in to watch this game class');
                default:
                    return this.$translate('Watch');
            }
        },
        buttonDisabled() {
            return ['already-registered', 'log-in-to-watch'].includes(this.buttonState);
        },
        buttonColor() {
            if (this.isWatching && !this.registrationOpen) {
                return 'warning';
            } else {
                return 'primary';
            }
        },
        subtitle() {
            let spaceLeft = this.gameClass.max_number_of_teams
                ? (this.gameClass.spaceLeft ? this.gameClass.spaceLeft : 0)
                : this.$translate('Unlimited');

            return `${this.$translate("Price")}: ${this.gameClass.price} | ${this.$translate("Spaces left")}: ${spaceLeft}`
        },
        showResultButton() {
            return this.gameClass.steps.some(step => step.divisions.some(division => division.matches_created))
        },
        registrationOpen() {
            let today = Date.newFull(this.$store.state.now30s.clone().yyyymmdd())
            let registrationStartDate = Date.newFull(this.gameClass.competition.registrationStartDate)
            return registrationStartDate < today;
        },
        registrationClosed() {
            let today = Date.newFull(this.$store.state.now30s.clone().yyyymmdd())
            let registrationEndDate = Date.newFull(this.gameClass.competition.registrationEndDate)
            return registrationEndDate < today;
        },
        isLoggedIn() {
            return this.$store.state.isLoggedIn;
        },
        isWatching() {
            if (this.isLoggedIn) {
                return this.$store.state.bookings?.gameclasswatches?.find(w => w.gameclass_id == this.gameClass.id && w.user_id == this.$store.state.user?.id);
            } else {
                return false;
            }
        },
    },
    methods: {
        goToGameclassOverview(gameClass) {
            const gameClassOverviewPage = this.$root.siteconfig?.pages?.gameClassOverview;
            const param = this.$root.siteconfig.pages.gameClassOverviewParamId;
            const link = `${gameClassOverviewPage}?${param}=${gameClass.id}`;
            this.$root.followLink(link);
        },
    },
}
</script>

<style scoped>
.wrap-text {
    white-space: normal;
}
</style>
